import PropTypes from 'prop-types';
import React from 'react';
import { Button } from '@sso/components';

import { instrumented } from '../traffic';

const Link = ({ children, target, design = 'inline', ...props }) => {
  const combined_props = { target, design, ...props };
  return <Button {...combined_props}>{children}</Button>;
};

Link.propTypes = {
  children: PropTypes.node,
  target: PropTypes.string,
  design: PropTypes.oneOf(['critical', 'inline', 'primary', 'secondary', 'control', 'stateless']),
};

Link.defaultProps = {
  target: '_parent',
};

export default instrumented(Link, ['onClick'], {}, { doNotPassTrafficName: true });
